<template>
  <div class="file">
    <div class="file_inner">
      <a class="file_icon" :href="filepath">
        <img v-if="hasImage" :src="imagePath" :alt="'Image' | translate">
      </a>
      <a class="file_name" :href="filepath">
        {{ item.name }}<span>{{ filesize }}</span>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "DocumentItem",
  props: {
    item: Object,
    route: String,
  },
  computed: {
    hasImage() {
      return !!this.item.image
    },
    imagePath() {
      return this.item.image
    },
    filesize() {
      let size = Number(this.item.size)
      if (size) {
        if (size > 1000 && size < 1000000) {
          return (size / 1000).toFixed(2) + ' ' + 'kB'
        } else if (size > 1000000) {
          return (size / 1000000).toFixed(2) + ' ' + 'MB'
        }
        return size + ' B'
      }
      return ''
    },
    filepath() {
      return this.route + encodeURIComponent(encodeURIComponent(this.item.path))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/downloads/documents/DocumentItem.vue